/** Shared UI/PDF terminology; locale coverage follows the central configuration. */
export const deliveryPlanningTranslations = {
    de: {
        title: 'Lieferplanung',
        enable: 'Lieferplanung verwenden',
        hint: 'Warenannahmezeiten und regelmäßige Liefertage für diese Lieferadresse hinterlegen.',
        receiving: 'Warenannahmezeiten',
        transport: 'Transportplan',
        basis: 'Bezug',
        ORDER: 'Bestellung',
        SHIPMENT: 'Versand',
        sourceOrder: 'Bestelltag',
        sourceShipment: 'Versandtag',
        deliveryDay: 'Liefertag',
        from: 'Von',
        until: 'Bis',
        addWindow: 'Zeitfenster hinzufügen',
        addRule: 'Weitere Zuordnung hinzufügen',
        weekdays: 'Wochentage',
        workweek: 'Mo–Fr',
        preview: 'Vorschau',
        empty: 'Nicht hinterlegt',
        inherited: 'Aus Lieferadresse übernommen',
        customized: 'Individuell für diesen Beleg angepasst',
        editOrder: 'Für diesen Auftrag ändern',
        editDelivery: 'Für diesen Lieferschein ändern',
        refresh: 'Aktuelle Angaben der Lieferadresse übernehmen',
        switchConfirmation: 'Die Lieferplanung wurde individuell angepasst. Mit OK die Angaben der neuen Lieferadresse übernehmen (ohne aktiven Plan werden die Angaben entfernt). Mit Abbrechen bleibt die bisherige Lieferadresse ausgewählt.',
        copyMain: 'Hauptadresse als Lieferadresse übernehmen',
        localHint: 'Lokale Uhrzeiten der Lieferstelle. Es werden keine Liefertermine berechnet.',
        invalid: 'Bitte vollständige, gültige Tage und Zeiten eingeben.',
        remove: 'Entfernen',
        RECEIVING_HOURS: 'Warenannahmezeiten',
        TRANSPORT_PLAN: 'Transportplan',
        days: ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'],
        transportOrder: 'Transportplan – Bestellung → Lieferung',
        transportShipment: 'Transportplan – Versand → Lieferung',
        errors: {
            time: 'Gültige Uhrzeit im Format HH:mm eingeben.',
            duplicate: 'Doppelte Tage oder Zeitfenster entfernen.',
            overnight: 'Bis muss nach Von liegen. Fenster über Mitternacht werden nicht unterstützt.',
            overlap: 'Zeitfenster desselben Tages dürfen sich nicht überschneiden.',
            sourceDuplicate: 'Jeden Ausgangstag genau einem Liefertag zuordnen.',
        },
    },
    en: {
        title: 'Delivery planning',
        enable: 'Use delivery planning',
        hint: 'Store receiving hours and regular delivery weekdays for this delivery address.',
        receiving: 'Receiving hours',
        transport: 'Transport schedule',
        basis: 'Based on',
        ORDER: 'Order',
        SHIPMENT: 'Shipment',
        sourceOrder: 'Order day',
        sourceShipment: 'Shipping day',
        deliveryDay: 'Delivery day',
        from: 'From',
        until: 'Until',
        addWindow: 'Add time window',
        addRule: 'Add another relation',
        weekdays: 'Weekdays',
        workweek: 'Mon–Fri',
        preview: 'Preview',
        empty: 'Not specified',
        inherited: 'Copied from delivery address',
        customized: 'Customized for this document',
        editOrder: 'Change for this order',
        editDelivery: 'Change for this delivery note',
        refresh: 'Copy current delivery address details',
        switchConfirmation: 'Delivery planning was customized. Select OK to use the new address details (an address without an active plan clears the details). Cancel keeps the previous delivery address selected.',
        copyMain: 'Copy main address as delivery address',
        localHint: 'Local times at the delivery location. No delivery dates are calculated.',
        invalid: 'Please enter complete, valid weekdays and times.',
        remove: 'Remove',
        RECEIVING_HOURS: 'Receiving hours',
        TRANSPORT_PLAN: 'Transport schedule',
        days: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
        transportOrder: 'Transport schedule – Order → Delivery',
        transportShipment: 'Transport schedule – Shipment → Delivery',
        errors: {
            time: 'Enter a valid time in HH:mm format.',
            duplicate: 'Remove duplicate days or time windows.',
            overnight: 'Until must be after From. Overnight windows are not supported.',
            overlap: 'Time windows on the same day must not overlap.',
            sourceDuplicate: 'Assign each source day to exactly one delivery day.',
        },
    },
    fr: {
        title: 'Planification des livraisons',
        enable: 'Utiliser la planification des livraisons',
        hint: 'Enregistrer les horaires de réception et les jours de livraison réguliers pour cette adresse.',
        receiving: 'Horaires de réception',
        transport: 'Plan de transport',
        basis: 'Référence',
        ORDER: 'Commande',
        SHIPMENT: 'Expédition',
        sourceOrder: 'Jour de commande',
        sourceShipment: 'Jour d’expédition',
        deliveryDay: 'Jour de livraison',
        from: 'De',
        until: 'À',
        addWindow: 'Ajouter un créneau',
        addRule: 'Ajouter une correspondance',
        weekdays: 'Jours de la semaine',
        workweek: 'LU–VE',
        preview: 'Aperçu',
        empty: 'Non renseigné',
        inherited: 'Repris de l’adresse de livraison',
        customized: 'Personnalisé pour ce document',
        editOrder: 'Modifier pour cette commande',
        editDelivery: 'Modifier pour ce bon de livraison',
        refresh: 'Reprendre les informations actuelles de l’adresse de livraison',
        switchConfirmation: 'La planification a été personnalisée. OK reprend les informations de la nouvelle adresse (sans plan actif, les informations sont effacées). Annuler conserve l’adresse précédente.',
        copyMain: 'Reprendre l’adresse principale comme adresse de livraison',
        localHint: 'Heures locales du lieu de livraison. Aucune date de livraison n’est calculée.',
        invalid: 'Veuillez saisir des jours et horaires complets et valides.',
        remove: 'Supprimer',
        RECEIVING_HOURS: 'Horaires de réception',
        TRANSPORT_PLAN: 'Plan de transport',
        days: ['LU', 'MA', 'ME', 'JE', 'VE', 'SA', 'DI'],
        transportOrder: 'Plan de transport – Commande → Livraison',
        transportShipment: 'Plan de transport – Expédition → Livraison',
        errors: {
            time: 'Saisir une heure valide au format HH:mm.',
            duplicate: 'Supprimer les jours ou créneaux en double.',
            overnight: 'La fin doit suivre le début. Les créneaux passant minuit ne sont pas pris en charge.',
            overlap: 'Les créneaux du même jour ne doivent pas se chevaucher.',
            sourceDuplicate: 'Associer chaque jour de départ à un seul jour de livraison.',
        },
    },
    es: {
        title: 'Planificación de entregas',
        enable: 'Usar planificación de entregas',
        hint: 'Guardar horarios de recepción y días habituales de entrega para esta dirección.',
        receiving: 'Horarios de recepción',
        transport: 'Plan de transporte',
        basis: 'Referencia',
        ORDER: 'Pedido',
        SHIPMENT: 'Envío',
        sourceOrder: 'Día del pedido',
        sourceShipment: 'Día de envío',
        deliveryDay: 'Día de entrega',
        from: 'Desde',
        until: 'Hasta',
        addWindow: 'Añadir franja horaria',
        addRule: 'Añadir otra relación',
        weekdays: 'Días de la semana',
        workweek: 'LU–VI',
        preview: 'Vista previa',
        empty: 'Sin especificar',
        inherited: 'Copiado de la dirección de entrega',
        customized: 'Personalizado para este documento',
        editOrder: 'Cambiar para este pedido',
        editDelivery: 'Cambiar para este albarán',
        refresh: 'Copiar los datos actuales de la dirección de entrega',
        switchConfirmation: 'La planificación se ha personalizado. Aceptar aplica los datos de la nueva dirección (sin un plan activo se borran los datos). Cancelar conserva la dirección anterior.',
        copyMain: 'Copiar dirección principal como dirección de entrega',
        localHint: 'Horas locales del lugar de entrega. No se calculan fechas de entrega.',
        invalid: 'Introduzca días y horas completos y válidos.',
        remove: 'Eliminar',
        RECEIVING_HOURS: 'Horarios de recepción',
        TRANSPORT_PLAN: 'Plan de transporte',
        days: ['LU', 'MA', 'MI', 'JU', 'VI', 'SÁ', 'DO'],
        transportOrder: 'Plan de transporte – Pedido → Entrega',
        transportShipment: 'Plan de transporte – Envío → Entrega',
        errors: {
            time: 'Introduzca una hora válida en formato HH:mm.',
            duplicate: 'Elimine días o franjas duplicados.',
            overnight: 'La hora final debe ser posterior a la inicial. No se admiten franjas que cruzan medianoche.',
            overlap: 'Las franjas del mismo día no pueden solaparse.',
            sourceDuplicate: 'Asigne cada día de origen a un único día de entrega.',
        },
    },
    tr: {
        title: 'Teslimat planlaması',
        enable: 'Teslimat planlamasını kullan',
        hint: 'Bu teslimat adresi için mal kabul saatlerini ve düzenli teslimat günlerini kaydedin.',
        receiving: 'Mal kabul saatleri',
        transport: 'Taşıma planı',
        basis: 'Referans',
        ORDER: 'Sipariş',
        SHIPMENT: 'Sevkiyat',
        sourceOrder: 'Sipariş günü',
        sourceShipment: 'Sevkiyat günü',
        deliveryDay: 'Teslimat günü',
        from: 'Başlangıç',
        until: 'Bitiş',
        addWindow: 'Zaman aralığı ekle',
        addRule: 'Başka eşleştirme ekle',
        weekdays: 'Haftanın günleri',
        workweek: 'Pzt–Cum',
        preview: 'Önizleme',
        empty: 'Belirtilmedi',
        inherited: 'Teslimat adresinden alındı',
        customized: 'Bu belge için özelleştirildi',
        editOrder: 'Bu sipariş için değiştir',
        editDelivery: 'Bu irsaliye için değiştir',
        refresh: 'Teslimat adresinin güncel bilgilerini al',
        switchConfirmation: 'Teslimat planlaması özelleştirildi. Tamam yeni adresin bilgilerini uygular (etkin plan yoksa bilgiler temizlenir). İptal önceki teslimat adresini korur.',
        copyMain: 'Ana adresi teslimat adresi olarak kopyala',
        localHint: 'Teslimat yerinin yerel saatleri. Teslimat tarihi hesaplanmaz.',
        invalid: 'Lütfen eksiksiz ve geçerli günler ve saatler girin.',
        remove: 'Kaldır',
        RECEIVING_HOURS: 'Mal kabul saatleri',
        TRANSPORT_PLAN: 'Taşıma planı',
        days: ['Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cmt', 'Paz'],
        transportOrder: 'Taşıma planı – Sipariş → Teslimat',
        transportShipment: 'Taşıma planı – Sevkiyat → Teslimat',
        errors: {
            time: 'HH:mm biçiminde geçerli bir saat girin.',
            duplicate: 'Yinelenen günleri veya zaman aralıklarını kaldırın.',
            overnight: 'Bitiş başlangıçtan sonra olmalıdır. Gece yarısını aşan aralıklar desteklenmez.',
            overlap: 'Aynı günün zaman aralıkları çakışamaz.',
            sourceDuplicate: 'Her çıkış gününü yalnızca bir teslimat gününe eşleştirin.',
        },
    },
};
//# sourceMappingURL=delivery-planning.js.map